import script from "./BulkOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkOrders.vue?vue&type=script&setup=true&lang=js"

import "./BulkOrders.vue?vue&type=style&index=0&id=2a230311&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a230311"]])

export default __exports__